import React from 'react';
import { Box } from '@chakra-ui/react';
import { useAppSelector } from '@/store/store';
import { selectCurrentGradient } from '@/store/slices/gradientSlice';

/**
 * Global gradient background component that renders two blurred orbs
 * on a dark backdrop. The gradient colors change on page navigation.
 */
export const GradientBackground: React.FC = () => {
  const gradientColors = useAppSelector(selectCurrentGradient);

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      bottom={0}
      bg="var(--color-gray-dark)"
      zIndex={-1}
      overflow="hidden"
      pointerEvents="none"
    >
      {/* Primary gradient orb - top left */}
      <Box
        className="gradient-orb"
        position="absolute"
        top="-100px"
        left="-100px"
        width="400px"
        height="400px"
        borderRadius="full"
        background={gradientColors.primary}
        filter="blur(120px)"
        transform="translateZ(0)"
        willChange="transform"
        transition="background var(--motion-glow-crossfade-duration) var(--motion-glow-crossfade-easing)"
      />

      {/* Secondary gradient orb - bottom right */}
      <Box
        className="gradient-orb"
        position="absolute"
        bottom="-100px"
        right="-100px"
        width="400px"
        height="400px"
        borderRadius="full"
        background={gradientColors.secondary}
        filter="blur(120px)"
        transform="translateZ(0)"
        willChange="transform"
        transition="background var(--motion-glow-crossfade-duration) var(--motion-glow-crossfade-easing)"
      />
    </Box>
  );
};

export default GradientBackground;
